const state = {
  processing: false,
  settlements: [],
  showSettlements: false,
  importResult: null,
};
export default state;
